import { useMemo } from 'react';
import { Fade, makeStyles } from '@material-ui/core';

import DataRow from './DataRow';
import { useDataStore, useTotalLoadedRows } from '../DataStore';
import { useContentHeight, useContentWidth, useRenderLayoutParams, useRows } from './RenderContext';
import RowLoadIndicator from './RowLoadIndicator';

const useStyles = makeStyles({
    root: {
        position: 'relative',
        display: 'block',
    },

    rowPositioner: {
        display: 'block',
        overflow: 'visible',
        position: 'absolute',
        height: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
    },
});

export default function ProgressiveScroller() {
    const classes = useStyles();

    const { hasLoaded, total } = useDataStore();
    const loadedRows = useTotalLoadedRows();
    const { topOffset } = useRenderLayoutParams();
    const contentHeight = useContentHeight();
    const contentWidth = useContentWidth();
    const rows = useRows();

    const spacerStyle = useMemo(() => ({ height: contentHeight, width: contentWidth }), [contentHeight, contentWidth]);

    const hasMoreRows = loadedRows < total;

    return (
        <Fade in={hasLoaded} timeout={250}>
            <div className={classes.root}>
                <div style={spacerStyle} />

                <div className={classes.rowPositioner} style={{ transform: `translateY(${topOffset}px)` }}>
                    {hasLoaded &&
                        total > 0 &&
                        rows.map(({ id, row, deleted }, index) => (
                            <DataRow key={id} row={row} deleted={deleted} index={index} />
                        ))}
                </div>

                {hasLoaded && hasMoreRows && <RowLoadIndicator />}
            </div>
        </Fade>
    );
}
